export const generateID = (): string => {
  // Generate a relatively unique ID
  return Math.floor(Math.random() * 10).toString() + (new Date().getTime())+Math.floor(Math.random() * 10).toString()
}